/**
 * @name phone-log
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuODMyIDE2LjU2OGExIDEgMCAwMDEuMjEzLS4zMDNsLjM1NS0uNDY1QTIgMiAwIDAxMTcgMTVoM2EyIDIgMCAwMTIgMnYzYTIgMiAwIDAxLTIgMkExOCAxOCAwIDAxMiA0YTIgMiAwIDAxMi0yaDNhMiAyIDAgMDEyIDJ2M2EyIDIgMCAwMS0uOCAxLjZsLS40NjguMzUxYTEgMSAwIDAwLS4yOTIgMS4yMzMgMTQgMTQgMCAwMDYuMzkyIDYuMzg0IiAvPgogIDxwYXRoIGQ9Ik0xNC4zOTYgNC4xNzFoNy4xNzEiIC8+CiAgPHBhdGggZD0iTTE3LjM0MyA4LjE3aDQuMjI0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/phone-log
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const PhoneLog: string = `
<svg
  class="lucide lucide-phone-log"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M13.832 16.568a1 1 0 001.213-.303l.355-.465A2 2 0 0117 15h3a2 2 0 012 2v3a2 2 0 01-2 2A18 18 0 012 4a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-.8 1.6l-.468.351a1 1 0 00-.292 1.233 14 14 0 006.392 6.384" />
  <path d="M14.396 4.171h7.171" />
  <path d="M17.343 8.17h4.224" />
</svg>
`;

export default PhoneLog;
